(() => {
  const readyAttr = 'data-doc-kicks-brand-carousel-ready';

  function setupBrandCarousel(scope = document) {
    scope.querySelectorAll('[data-brand-carousel]').forEach((carousel) => {
      if (carousel.hasAttribute(readyAttr)) return;

      const track = carousel.querySelector('.shop-by-brand__track');
      const slides = Array.from(carousel.querySelectorAll('.shop-by-brand__slide'));
      const previousButton = carousel.querySelector('.slider-button--prev');
      const nextButton = carousel.querySelector('.slider-button--next');

      if (!track || slides.length < 2 || !previousButton || !nextButton) return;

      carousel.setAttribute(readyAttr, 'true');
      track.style.overscrollBehaviorX = 'none';

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
      const getMaxScroll = () => Math.max(track.scrollWidth - track.clientWidth, 0);
      const getClampedScrollLeft = () => clamp(Number.isFinite(track.scrollLeft) ? track.scrollLeft : 0, 0, getMaxScroll());

      const syncScrollBounds = () => {
        const clamped = getClampedScrollLeft();

        if (Math.abs(track.scrollLeft - clamped) > 1) {
          track.scrollTo({ left: clamped, behavior: 'auto' });
        }

        return clamped;
      };

      const getStep = () => {
        const visibleSlides = slides.filter((slide) => slide.clientWidth > 0);
        if (visibleSlides.length < 2) return visibleSlides[0]?.clientWidth || track.clientWidth;

        return visibleSlides[1].offsetLeft - visibleSlides[0].offsetLeft || visibleSlides[0].clientWidth;
      };

      const getVisibleCount = () => Math.max(Math.round(track.clientWidth / Math.max(getStep(), 1)), 1);
      const getPageStep = () => getStep() * getVisibleCount();

      const updateControls = () => {
        const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        const scrollLeft = syncScrollBounds();
        const isSinglePage = maxScroll <= 1;

        carousel.classList.toggle('shop-by-brand__slider--single-page', isSinglePage);
        previousButton.toggleAttribute('disabled', scrollLeft <= 1);
        nextButton.toggleAttribute('disabled', scrollLeft >= maxScroll - 1);
      };

      const scrollByPage = (direction) => {
        const current = syncScrollBounds();
        const maxScroll = getMaxScroll();
        if ((direction < 0 && current <= 1) || (direction > 0 && current >= maxScroll - 1)) {
          updateControls();
          return;
        }

        const target = clamp(current + getPageStep() * direction, 0, maxScroll);

        track.scrollTo({
          left: target,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });

        requestUpdate();
        window.setTimeout(requestUpdate, 360);
      };

      let queued = false;
      const requestUpdate = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          updateControls();
        });
      };

      previousButton.addEventListener('click', (event) => {
        event.preventDefault();
        scrollByPage(-1);
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        scrollByPage(1);
      });

      track.addEventListener(
        'scroll',
        () => {
          syncScrollBounds();
          requestUpdate();
        },
        { passive: true }
      );
      window.addEventListener('resize', requestUpdate);
      updateControls();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupBrandCarousel());
  } else {
    setupBrandCarousel();
  }

  document.addEventListener('shopify:section:load', (event) => setupBrandCarousel(event.target));
})();
